import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { UserTicketingService } from '../../user-tickets.service';
import { HelperService } from 'src/app/helper.service';
import { ToasterService } from 'src/app/toaster.service';
import { Pagination, Table } from 'src/app/shared/types';

import { TICKET_STATUS_MAPPING } from 'src/app/shared/constants';
import {
  createTicketConversationCell,
  createTicketLinkTableData,
  createTicketOrderIdCells,
  createTicketTableData,
  getTicketPaginationCount,
  normalizeTicketDescription,
  openTicketConversation,
} from 'src/app/shared/ticket-table.helper';

@Component({
  selector: 'app-customer-tickets',
  templateUrl: './customer-tickets.component.html',
  styleUrls: ['./customer-tickets.component.css']
})
export class CustomerTicketsComponent implements OnInit {

  constructor(
    public ticketingService: UserTicketingService,
    private toasterService: ToasterService,
    public dialog: MatDialog,
  ) { }

  @Input() customerId: any;
  @Input() mobile:any;
  @Input() customerDetailsToggleableHeaders: string[];
  @Output() toggleHeaders: EventEmitter<any> = new EventEmitter();
  customerTickets: Table;
  dataLoaded = false;


  ngOnInit() {
    this.declareTable();
  }

 declareTable() {
    this.customerTickets = new Table({
      toggleableHeaders: this.customerDetailsToggleableHeaders,
      headers: {
        date: 'Created Date',
        ticketId: 'Ticket ID',
        rdOrderId: 'RD Order ID',
        orderId: 'Order ID',
        subject: 'Subject',
        description: 'Description',
        status: 'Status',
        reason: 'Reason',
        subReason: 'Sub Reason',
        conversation: 'Conversation'
      },
      pagination: new Pagination(0, 10, 0, [10,15,20],0, true),
      selectedHeader: 4,
      defaultError: 'No Logs Found',
      onRefresh: () => {
        this.customerTickets = null;
        this.ngOnInit();
      },
      data: []
    });
    this.getTickets();
  }

  async getTickets(pageNumber = 1, perPage = 10) {
    this.dataLoaded = false;
    try {
      const response : any = await this.ticketingService.fetchUserTicketsByMobileV3(
        this.customerId, 'customer', this.mobile, pageNumber, perPage
      ).toPromise();
      this.dataLoaded = true;
      if (response && response.tickets) {
        const formattedTickets = this.formatCustomerTickets(response.tickets);
        this.customerTickets.data = formattedTickets;
        this.customerTickets.pagination.perPage = perPage;
        this.customerTickets.pagination.count = getTicketPaginationCount(
          pageNumber - 1,
          perPage,
          response.tickets.length
        );
      }
    } catch(error) {
      console.log('Error while fetching tickets for customer ---', error);
      this.dataLoaded = true;
    }
  }

  formatCustomerTickets(customerTickets = []) {
    const formatedTickets = [];
    customerTickets.forEach((item) => {
      const ticket = {
        date: createTicketTableData(HelperService.dateString(item.created_at)),
        ticketId: createTicketLinkTableData(item.ticket_id, item.redirection_url),
        ...createTicketOrderIdCells(item),
        subject: createTicketTableData(item.subject || ''),
        description: createTicketTableData(normalizeTicketDescription(item.description_text) || ''),
        reason: createTicketTableData(item.reason || ''),
        subReason: createTicketTableData(item.sub_reason918254 || ''),
        status: createTicketTableData(TICKET_STATUS_MAPPING[item.status] || ''),
        conversation: createTicketConversationCell(() => this.openConversation(item.ticket_id)),
      };
      formatedTickets.push(ticket);
    });
    return formatedTickets;
  }

  openConversation(ticketId) {
    openTicketConversation({
      ticketingService: this.ticketingService,
      dialog: this.dialog,
      toasterService: this.toasterService,
      userId: this.customerId,
      ticketId,
      formatDate: HelperService.dateString,
      userLabel: 'Customer',
    });
  }

  changeInHeader(header) {
    this.toggleHeaders.emit(header);
  }

  onPaginationChange(event) {
    this.getTickets((event.pageNo + 1), event.perPage);
  }
}
